/**
 * @fileoverview POST handler for the "/generative_ai/upload_dalle_image" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiUploadDalleImageCacheKeys } from "./constants";
import type { PostGenerativeAiUploadDalleImageProps, GenerativeAiUploadDalleImageResult } from "./types";

export const postGenerativeAiUploadDalleImage = reactQueryMutationAdapter(
  generativeAiUploadDalleImageCacheKeys,
  ({
    imageToken,
    territoryIds,
  }: PostGenerativeAiUploadDalleImageProps): Promise<GenerativeAiUploadDalleImageResult> => {
    return fetch(
      "/generative_ai/upload_dalle_image",
      "POST",
      { image_token: imageToken, territory_ids: territoryIds },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
